import React, {useRef, useCallback} from "react";

import LoginForm from "../component/LoginForm";
import asahiLogo from "../../../assets/asahi_logo.png";
import sapB1Logo from "../../../assets/sap_business_one_logo.jpg"
import { ButtonDesign } from "@ui5/webcomponents-react/lib/ButtonDesign";
import { Button } from "@ui5/webcomponents-react/lib/Button";

import "./Login.css";

const Login = (props) => {

  const dialogRef = useRef();
  const onButtonClick = useCallback(() => {
    dialogRef.current.open();
  }, [dialogRef]);

  return (
    <div className="base-container">
      <div className="logo_container">
        <img src={asahiLogo} alt="AsahiLogo" className="asahi_logo"></img>
      </div>
      <div className="dialog__button_container">
        <Button
          className="dialog__button"
          onClick={onButtonClick}
          design={ButtonDesign.Emphasized}
        >
          Login
        </Button>
      </div>
      <div className="logo_container">
        <img src={sapB1Logo} alt="SapB1Logo" className="sapb1_logo"></img>
      </div>
      <LoginForm dialogRef={dialogRef}  login={props.login} />
    </div>
  );
};

export default Login;
